<template>
  <div class="mainbox">
    <div class="cnm">
      <div class="pimg">
        <img
          v-if="etype == 3"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k80.png"
          alt=""
        />
        <img
          v-else-if="etype == 5 || etype == 1"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k83.png"
          alt=""
        />
        <img
          v-else
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k84.png"
          alt=""
        />
      </div>
      <div class="list">
        <div>
          <div>
            <div>
              <qriously :value="apkUrl1" class="img" :size="116" />
            </div>
            <div style="margin-left: 30px">
              <div>聚学堂 APP</div>
              <div style="margin-top: 10px">一站式学习服务平台</div>
              <div>
                <div
                  :class="`eeee${
                    etype == 5 || etype == 1 ? '5' : etype == 3 ? '3' : ''
                  }`"
                  @click="downloadApp(1)"
                  style="margin-right: 10px"
                >
                  <div></div>
                  iphone下载
                </div>
                <div
                  :class="`eee${
                    etype == 5 || etype == 1 ? '5' : etype == 3 ? '3' : ''
                  }`"
                  @click="downloadApp(2)"
                >
                  <div style="height: 15px"></div>
                  Android下载
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="j1">
          <div>
            <div>
              <qriously :value="apkUrl2" class="img" :size="116" />
            </div>
            <div style="margin-left: 30px">
              <div>聚学U APP</div>
              <div style="margin-top: 10px">
                学习规划服务学习平台，专业助力备考
              </div>
              <div>
                <div
                  :class="`eeee${
                    etype == 5 || etype == 1 ? '5' : etype == 3 ? '3' : ''
                  }`"
                  @click="downloadApp(3)"
                  style="margin-right: 10px"
                >
                  <div></div>
                  iphone下载
                </div>
                <div
                  :class="`eee${
                    etype == 5 || etype == 1 ? '5' : etype == 3 ? '3' : ''
                  }`"
                  @click="downloadApp(4)"
                >
                  <div style="height: 15px"></div>
                  Android下载
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pimgs">
        <img
          v-if="etype == 3"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k81.png"
          alt=""
        />
        <img
          v-else-if="etype == 5 || etype == 1"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k82.png"
          alt=""
        />
        <img
          v-else
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k85.png"
          alt=""
        />
      </div>
      <div class="list lists">
        <div class="j2">
          <div>
            <div>
              <img
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k92.jpg"
                alt=""
              />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 44px;
              "
            >
              <div>自考聚题库小程序</div>
              <div style="margin-top: 20px">汇集考点，助力全阶段上岸</div>
            </div>
          </div>
        </div>
        <div class="j3">
          <div>
            <div>
              <img
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k93.jpg"
                alt=""
              />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 44px;
              "
            >
              <div>聚词汇小程序</div>
              <div style="margin-top: 20px">每日十分钟，单词轻松记，考试全搞定</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list lists">
        <div class="j4">
          <div>
            <div>
              <img
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/a2.jpg"
                alt=""
              />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 44px;
              "
            >
              <div>成考聚题库小程序</div>
              <div style="margin-top: 20px">精准考前押密，助你轻松上岸</div>
            </div>
          </div>
        </div>
        <div class="j5">
          <div>
            <div>
              <img
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/a3.jpg"
                alt=""
              />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 44px;
              "
            >
              <div>专升本聚题库小程序</div>
              <div style="margin-top: 20px">试题免费刷，满足备考所需</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list lists">
        <div class="j6">
          <div>
            <div>
              <img
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/a4.jpg"
                alt=""
              />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 44px;
              "
            >
              <div>聚学云小程序</div>
              <div style="margin-top: 20px">一站式学习服务平台</div>
            </div>
          </div>
        </div>
        <div class="j7">
          <div>
            <div>
              <img
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/a1.jpg"
                alt=""
              />
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 44px;
              "
            >
              <div>聚学U小程序</div>
              <div style="margin-top: 20px">
                学习规划服务学习平台，专业助力备考！
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDomain } from "@/api/cookies";
import { getStore, getAndroidDownloadPackage,checkVersion } from "@/api/home";
export default {
  components: {},
  data() {
    return {
      domain: null,
      apkUrl1: null,
      apkUrl2: null,
      etype: "",
    };
  },
  created() {
    this.domain = getDomain();
    this.etype = this.domain.entrantsType;
    this.getAndroidDownloadPackage();
  },
  methods: {
    downloadApp(type) {
      if (type == 1) {
        window.open(
          "https://apps.apple.com/cn/app/%E8%81%9A%E5%AD%A6%E5%A0%82/id1611513973",
          "_blank"
        );
      } else if (type == 2) {
        window.open(this.apkUrl2, "_blank");
      } else if (type == 3) {
        window.open(
          "https://apps.apple.com/cn/app/%E8%81%9A%E5%AD%A6u/id6503936407",
          "_blank"
        );
      } else {
        window.open(this.apkUrl1, "_blank");
      }
    },
    getAndroidDownloadPackage() {
      checkVersion({ appType: "新版聚学U",platform:0 }).then((res) => {
        this.apkUrl1 = res.data.apkUrl;
      });
      checkVersion({ appType: "聚学堂", platform:0}).then((res) => {
        this.apkUrl2 = res.data.apkUrl;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mainbox {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  padding: 29px;
  padding-bottom: 80px;
  margin-top: 20px;
  box-shadow: 0px 0px 6px 1px rgba(204, 204, 204, 0.26);
  border-radius: 4px 4px 4px 4px;
  margin-bottom: 50px;
  // height: 100vh;
  // overflow-y: scroll;

  .cnm {
    width: 1043px;
    margin: 0 auto;
  }
}

.pimg {
  width: 216px;
  margin: 0 auto;

  img {
    width: 216px;
  }
}

.pimgs {
  width: 530px;
  height: 56px;
  margin: 0 auto;
  margin-top: 74px;

  img {
    width: 100%;
  }
}

.list {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  > div {
    position: relative;
    width: 486px;
    height: 432px;
    background: #f7f7fa;
    border-radius: 13px 13px 13px 13px;
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k73.png");
    background-size: 100% 100%;

    > div {
      position: absolute;
      bottom: 0;
      width: 486px;
      height: 146px;
      background: #f7f7fa;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      padding: 17px 0 17px 50px;

      > div:nth-child(1) {
        width: 113px;
        height: 113px;
        border-radius: 4px 4px 4px 4px;
      }

      > div:nth-child(2) {
        > div:nth-child(1) {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
        }

        > div:nth-child(2) {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }

        > div:nth-child(3) {
          margin-top: 20px;
          display: flex;
          align-items: center;

          > div {
            width: 110px;
            height: 34px;
            border-radius: 17px 17px 17px 17px;
            border: 1px solid #00ab8c;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #00ab8c;
            cursor: pointer;

            > div {
              width: 12px;
              height: 12px;
              margin-right: 4px;
              background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k68.png");
              background-size: 100% 100%;
            }

            &:hover {
              background: #00ab8c;

              color: #ffffff;
              > div {
                background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k70.png");
                background-size: 100% 100%;
              }
            }
          }
          > div:nth-child(2) {
            > div {
              background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k71.png");
              background-size: 100% 100%;
            }
            &:hover {
              background: #00ab8c;

              color: #ffffff;
              > div {
                background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k69.png");
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }
  }
}
.j1 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k72.png") !important;
  background-size: 100% 100% !important;
}
.j2 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k74.png") !important;
  background-size: 100% 100% !important;
}
.j3 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k75.png") !important;
  background-size: 100% 100% !important;
}
.j4 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k76.png") !important;
  background-size: 100% 100% !important;
}
.j5 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k77.png") !important;
  background-size: 100% 100% !important;
}
.j6 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k78.png") !important;
  background-size: 100% 100% !important;
}
.j7 {
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k79.png") !important;
  background-size: 100% 100% !important;
}
img {
  width: 100%;
}
.eeee {
  border: 1px solid #ff5d51 !important;
  color: #ff5d51 !important;
  > div {
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k86.png") !important;
    background-size: 100% 100% !important;
  }
  &:hover {
    background: #ff5d51 !important;

    color: #ffffff !important;
    > div {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k88.png") !important;
      background-size: 100% 100% !important;
    }
  }
}
.eee {
  border: 1px solid #ff5d51 !important;
  color: #ff5d51 !important;

  > div {
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k89.png") !important;
    background-size: 100% 100% !important;
  }
  &:hover {
    background: #ff5d51 !important;

    color: #ffffff !important;
    > div {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k87.png") !important;
      background-size: 100% 100% !important;
    }
  }
}

.eeee3 {
  border: 1px solid #00ab8c !important;
  color: #00ab8c !important;

  > div {
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k68.png") !important;
    background-size: 100% 100% !important;
  }
  &:hover {
    background: #00ab8c !important;

    color: #ffffff !important;
    > div {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k70.png") !important;
      background-size: 100% 100% !important;
    }
  }
}
.eee3 {
  border: 1px solid #00ab8c !important;
  color: #00ab8c !important;

  > div {
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k71.png") !important;
    background-size: 100% 100% !important;
  }
  &:hover {
    background: #00ab8c !important;

    color: #ffffff !important;
    > div {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k69.png") !important;
      background-size: 100% 100% !important;
    }
  }
}
.eeee5 {
  border: 1px solid #0270e8 !important;
  color: #0270e8 !important;
  > div {
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k90.png") !important;
    background-size: 100% 100% !important;
  }
  &:hover {
    background: #0270e8 !important;

    color: #ffffff !important;
    > div {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k70.png") !important;
      background-size: 100% 100% !important;
    }
  }
}
.eee5 {
  border: 1px solid #0270e8 !important;
  color: #0270e8 !important;
  > div {
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k91.png") !important;
    background-size: 100% 100% !important;
  }
  &:hover {
    background: #0270e8 !important;

    color: #ffffff !important;
    > div {
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/k69.png") !important;
      background-size: 100% 100% !important;
    }
  }
}
</style>
